import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Mesh, MeshBasicMaterial, SphereGeometry, Vector3 } from 'three';
export var GroundedSkybox = /*#__PURE__*/function (_Mesh) {
  _inherits(GroundedSkybox, _Mesh);
  var _super = _createSuper(GroundedSkybox);
  function GroundedSkybox() {
    var _this;
    _classCallCheck(this, GroundedSkybox);
    _this = _super.call(this, undefined, new MeshBasicMaterial({
      depthWrite: false
    }));
    _this.height = 0;
    _this.radius = 0;
    _this.resolution = 0;
    _this.userData.noHit = true;
    return _this;
  }
  _createClass(GroundedSkybox, [{
    key: "map",
    get: function get() {
      return this.material.map;
    },
    set: function set(skybox) {
      this.material.map = skybox;
    }
  }, {
    key: "isUsable",
    value: function isUsable() {
      return this.height > 0 && this.radius > 0 && this.geometry != null && this.map != null;
    }
  }, {
    key: "updateGeometry",
    value: function updateGeometry() {
      var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.height;
      var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.radius;
      var resolution = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 128;
      if (height != this.height || radius != this.radius || resolution != this.resolution) {
        this.height = height;
        this.radius = radius;
        this.resolution = resolution;
        if (height > 0 && radius > 0) {
          this.geometry.dispose();
          this.geometry = makeGeometry(height, radius, resolution);
        }
      }
    }
  }]);
  return GroundedSkybox;
}(Mesh);
function makeGeometry(height, radius, resolution) {
  var geometry = new SphereGeometry(radius, 2 * resolution, resolution);
  geometry.scale(1, 1, -1);
  var pos = geometry.getAttribute('position');
  var tmp = new Vector3();
  for (var i = 0; i < pos.count; ++i) {
    tmp.fromBufferAttribute(pos, i);
    if (tmp.y < 0) {
      // Smooth out the transition from flat floor to sphere:
      var y1 = -height * 3 / 2;
      var f = tmp.y < y1 ? -height / tmp.y : 1 - tmp.y * tmp.y / (3 * y1 * y1);
      tmp.multiplyScalar(f);
      tmp.toArray(pos.array, 3 * i);
    }
  }
  pos.needsUpdate = true;
  return geometry;
}